import ConvergenceLayoutStyleComponent from "../../../containers/components/convergence-2025-layout-style.component";
import ConvergenceHeader from "../../../components/header/convergence-2025-header";

type headerBanner = {
  bannerImage: string;
  headerText: string;
  topCommonMesage: string;
  mobileBanner: string;
};

const ConvergenceBanner = (props: headerBanner) => {

  return (
    <>
      <ConvergenceHeader />
      <ConvergenceLayoutStyleComponent />

      <ConvergenceBannerStyleComponent {...props} />
      <div id="header-image" className="header-image">
        <img src={props.mobileBanner} alt="Event Hero" className="mobile-image" />
        <div className="top-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
      </div>

      <div dangerouslySetInnerHTML={{ __html: props.topCommonMesage }}></div>
      <div className="bottom-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
    </>
  );
};

export default ConvergenceBanner;

const ConvergenceBannerStyleComponent = (props: headerBanner) => {
  return (
    <>
      <style>
        {`
          @media(min-width: 1024px){
            .header-image{
              background-image: url( ${props.bannerImage});
              background-position: center bottom !important;
            }
          }
          @media(min-width: 1024px){
            .mobile-image{
              display: none;
            }
          }
          @media(max-width: 1024px){
            .top-text{
              display: none;
            } 
          }
          @media(min-width: 1025px){
            .bottom-text{
              display: none;
            }
          }
        `}
      </style>
    </>
  );
};
